export const enum Position {
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
}

export const enum LabelPosition {
  END = 'end',
  START = 'start',
}
